import React from 'react';

interface Props {
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export default function UserPagination({ hasPrevious, hasNext, onPrevious, onNext }: Props) {
  return (
    <div className="d-flex justify-content-end gap-2 p-3">
      <button className="btn btn-light" disabled={!hasPrevious} onClick={onPrevious}>Previous</button>
      <button className="btn btn-light" disabled={!hasNext} onClick={onNext}>Next</button>
    </div>
  );
}
